import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import Close from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "../CustomButtons/Button";

//Core components
import CustomInput from "./CustomInput";

//React Color picker https://casesandberg.github.io/react-color/
import { ChromePicker } from "react-color";

//Style for this view
import colorPickerStyle from "../../assets/jss/material-dashboard-pro-react/components/colorPickerStyle";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";

class ColorPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayColorPicker: false,
    };
  }

  handleChange = (color, event) => {
    if (!this.handleRemoveBusy) {
      if (this.props.onChange) {
        this.props.onChange(this.props.name, color);
      }
    }
  };

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handeRemove = (event) => {
    event.stopPropagation();
    if (this.props.onChange) {
      this.props.onChange(this.props.name, { hex: "" });
    }
  };

  convertColor = () => {
    let color = this.props.value !== null ? this.props.value : "";
    return color;
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        {this.state.displayColorPicker ? (
          <div className={classes.popover}>
            <ChromePicker color={this.convertColor()} disableAlpha={true} onChange={this.handleChange} />
            <div className={classes.buttonBar}>
              <Button color={"success"} onClick={this.handleClick} size={"sm"}>
                <TranslationWrapper tDefault={"Aanpassen"} tKey={"global.colerpicker"} />
              </Button>
            </div>
          </div>
        ) : (
          <CustomInput
            formControlProps={{
              width: "80px",
            }}
            id={this.props.id}
            inputProps={{
              name: this.props.name,
              type: "text",
              value: this.convertColor(),
              onClick: this.handleClick,
              startAdornment:
                this.convertColor() !== "" ? (
                  <InputAdornment position={"start"}>
                    <Button
                      style={{
                        backgroundColor: this.convertColor() !== undefined ? this.convertColor() : "#FF0000",
                      }}
                    >
                      {this.convertColor() !== undefined ? "" : "???"}
                    </Button>
                  </InputAdornment>
                ) : (
                  <InputAdornment position={"start"}>...</InputAdornment>
                ),
              endAdornment:
                this.convertColor() !== "" ? (
                  <InputAdornment position={"end"}>
                    <Close className={classes.clear} onClick={this.handeRemove} />
                  </InputAdornment>
                ) : undefined,
            }}
          />
        )}
      </div>
    );
  }
}

ColorPicker.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default withStyles(ColorPicker, colorPickerStyle);
